//@ts-ignore
//@ts-nocheck
import { Grid } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getGuestDataService, handleGuestDataService } from "../../api/Guests";
import MarkLogoWhite from "../../assets/images/MarkLogo.png";
import MaskTextField from "../../components/MaskTextField/MaskTextField";
import RadioButtonGroup from "../../components/RadioButtonGroup";
import TextField from "../../components/TextField/TextField";
import { RootState } from "../../stores/AppReducers";
import GlobalLoadingActions from "../../stores/GlobalLoading/Actions";
import { StyledButton } from "../../theme/Styles";
import RequestStatusModal from "../Payment/components/RequestStatusModal";
import { FormSchema, TRegisterBody } from "./GuestsConstants";
import {
  Container,
  FormContainer,
  LeftContainer,
  LogoImg,
  RightContainer,
} from "./styles/GuestsStyles";

function Guests(props: ScreenProps) {
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [showRequestStatusModal, setShowRequestStatusModal] = useState(false);
  const [statusModalMessage, setStatusModalMessage] = useState();

  const formik = useFormik({
    initialValues: {
      name: "",
      lastname: "",
      email: "",
      documentType: 1,
      documentNumber: "",
    },
    validationSchema: FormSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, actions) => {
      handleGuestData(values);
    },
  });

  const handleGuestData = async (data: TRegisterBody) => {
    try {
      const response = await handleGuestDataService({
        token,
        document: data.documentNumber,
        tipo_documento: data.documentType,
        email: data.email,
        firstname: data.name,
        lastname: data.lastname,
      });
      if (response.ok) {
        setShowRequestStatusModal(true);
        setStatusModalMessage({
          variant: "success",
          content: "Modificación exitosa",
        });
      } else {
        setShowRequestStatusModal(true);
        setStatusModalMessage({
          variant: "error",
          content: "Ha ocurrido un error.",
        });
      }
    } catch (error) {}
  };

  const getAndSetUserDataByToken = async (token: string) => {
    try {
      const response = await getGuestDataService(token);
      if (response?.ok) {
        formik.setFieldValue("documentType", response.data?.tipo_documento ?? 1);
        formik.setFieldValue("documentNumber", response.data?.document ?? '');
        formik.setFieldValue("name", response.data?.firstname ?? '');
        formik.setFieldValue("lastname", response.data?.lastname ?? '');
        formik.setFieldValue("email", response.data?.email ?? '');
      } else {
        throw new Error("error");
      }
    } catch (error) {
      navigate("/");
    }
  };

  /* Componentdidmount */
  useEffect(() => {
    /* from params cases */
    if (token !== null) {
      getAndSetUserDataByToken(token);
    } else {
      navigate("/");
    }
  }, [token]);

  return (
    <Container>
       <RequestStatusModal
        setShowDialogModal={() => {
          setShowRequestStatusModal();
          formik.resetForm();
        }}
        message={statusModalMessage}
        showDialogModal={showRequestStatusModal}
      />

      <LeftContainer>
        <LogoImg src={MarkLogoWhite} />
      </LeftContainer>
      <RightContainer>
        <FormContainer>
          <h1>MODIFICAR LA INFORMACIÓN DEL INVITADO</h1>
          <br />
          <Grid
            alignItems="center"
            container
            direction="row"
            justifyContent={"flex-start"}
            spacing={{ xs: 1, md: 1.5 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={4} md={6}>
              <RadioButtonGroup
                required
                row
                id="documentType"
                title="Tipo de documento"
                options={[
                  { label: "Cédula", value: 1 },
                  { label: "Pasaporte", value: 2 },
                ]}
                value={formik.values.documentType}
                onChange={formik.handleChange}
                error={
                  formik.touched.documentType &&
                  Boolean(formik.errors.documentType)
                }
                helperText={
                  formik.touched.documentType && formik.errors.documentType
                }
              />
            </Grid>
            <Grid item xs={12} sm={4} md={6}>
              <MaskTextField
                required
                id="documentNumber"
                type="text"
                maskType={
                  formik.values.documentType == "1" ? "cedula" : "passport"
                }
                title="Documento"
                placeholder="Documento"
                value={formik.values.documentNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.documentNumber &&
                  Boolean(formik.errors.documentNumber)
                }
                helperText={
                  formik.touched.documentNumber && formik.errors.documentNumber
                }
              />
            </Grid>
            <Grid item xs={4} sm={4} md={6}>
              <TextField
                id="name"
                type="text"
                title="Nombres"
                placeholder="Nombres"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.name && Boolean(formik.errors.name)
                }
                helperText={
                  formik.touched.name && formik.errors.name
                }
              />
            </Grid>
            <Grid item xs={4} sm={4} md={6}>
              <TextField
                id="lastname"
                type="text"
                title="Apellidos"
                placeholder="Apellidos"
                value={formik.values.lastname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.lastname && Boolean(formik.errors.lastname)
                }
                helperText={
                  formik.touched.lastname && formik.errors.lastname
                }
              />
            </Grid>
            <Grid item xs={4} sm={4} md={6}>
              <TextField
                id="email"
                type="email"
                title="Email"
                placeholder="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.email && Boolean(formik.errors.email)
                }
                helperText={
                  formik.touched.email && formik.errors.email
                }
              />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="flex-end"
            direction="row"
            justifyContent={"end"}
            spacing={{ xs: 1, md: 1.5 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={4} sm={8} md={3}>
              <StyledButton
                onClick={() => formik.handleSubmit()}
                variant="contained"
              >
                Continuar
              </StyledButton>
            </Grid>
          </Grid>
          <br />
        </FormContainer>
      </RightContainer>
    </Container>
  );
}

interface ScreenProps extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.signin.user,
});

const mapDispatchToProps = {
  showGlobalLoading: GlobalLoadingActions.showGlobalLoading,
  hideGlobalLoading: GlobalLoadingActions.hideGlobalLoading,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Guests);
